import { render, staticRenderFns } from "./RestaurantDictionary.vue?vue&type=template&id=8c6d6cc2"
import script from "./RestaurantDictionary.vue?vue&type=script&lang=js"
export * from "./RestaurantDictionary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports